<mat-nav-list>
  @for(zone of zones; track zone) {
  <mat-list-item (click)="zoneClick.emit(zone.id)">
    @if(!isHandset) {
    <img
      matListAvatar
      src="{{ zone.shape.img }}"
      alt="asset-icon"
      class="mat-list-avatar" />
    }
    <div class="mat-list-text">
      <div class="mat-list-text-title">
        <h3 matLine>
          {{ zone.name }}
          @if(isHandset) {<br />}
          <span class="shape-type">({{ zone.shape.label | transloco }})</span>
        </h3>
      </div>
      <div class="mat-list-text-description">
        <span class="text-black-50">{{ zone.description }}</span>
      </div>
    </div>
    <ng-container *lorenShowForPrivileges="[privileges.WRITE_GEOFENCE_ZONES]">
      <button
        mat-button
        color="warn"
        class="float-right"
        (click)="zoneDeleteClick.emit(zone.id)">
        <mat-icon>delete</mat-icon>
        @if(!isHandset) {
        {{ "operations.delete" | transloco }}

        }
      </button>
      <button
        mat-button
        color="accent"
        class="float-right"
        (click)="zoneEditClick.emit(zone)">
        <mat-icon>edit</mat-icon>
        @if(!isHandset) {
        {{ "operations.edit" | transloco }}
        }
      </button>
    </ng-container>
  </mat-list-item>
  }
</mat-nav-list>
